<template>
  <el-container class="form-container">
    <el-aside class="left-aside">
      <div style="margin: 10px 0px 5px 10px ">表单组件</div>
      <div class="component-group">
        <draggable
            class="draggable"
            :list="componentList"
            item-key="component"
            :clone="widgetClone"
            :group="{name: 'component-drag-group', pull: 'clone', put: false}"
            :sort="false"
            @start="drag=true" @end="drag=false">
          <template #item="{ element }">
            <div class="component-item">
              <SvgIcon :name="element.icon"/>
              <span>{{ element.label }}</span>
            </div>
          </template>

        </draggable>

      </div>
    </el-aside>

    <el-container class="main-container">
      <el-header class="header" style="text-align: right">
        <el-button link type="primary" icon="ElIconDelete" @click="empty">清空</el-button>
        <el-button link type="primary" icon="ElIconFinished" @click="finish">完成设计</el-button>
      </el-header>
      <el-main class="frame-main">
        <el-scrollbar>
          <div class="frame-main-content">
            <el-form style="height: 100%" :label-width="formConfig.label_width">
              <el-row class="not-select" v-if="formConfig.items.length==0">
                请从左侧拖拽来添加字段
              </el-row>
              <draggable
                  class="form-item-list"
                  :list="formConfig.items"
                  item-key="id"
                  :group="{name: 'component-drag-group', pull: 'clone', put: true}"
                  handle=".drag-move"
                  ghost-class="ghost"
                  @add="onDragAdd"
              >
                <template #item="{ element,index }">
                  <div class="form-item" :class="isSelect(index)?'selected':''">
                    <el-form-item v-if="element.component==='button'" label="" label-width="0" @click="selectWidget(index)">
                      <FrameButton :button="element" disabled></FrameButton>
                    </el-form-item>
                    <el-form-item v-else :label="element.label" @click="selectWidget(index)">
                      <FrameItem
                          v-model="formInfo[element.data_key]"
                          :item="element"
                      ></FrameItem>
                    </el-form-item>
                    <div class="drag-control" v-if="isSelect(index)">
                      <div class="drag-move">
                        <el-icon class="icon">
                          <ElIconRank/>
                        </el-icon>
                      </div>
                      <div class="item-control">
                        <el-icon class="icon" @click="copyWidget(index)">
                          <ElIconCopyDocument/>
                        </el-icon>
                        <el-icon class="icon" @click="deleteWidget(index)">
                          <ElIconDelete/>
                        </el-icon>
                      </div>
                    </div>
                  </div>

                </template>
              </draggable>
            </el-form>
          </div>
        </el-scrollbar>
      </el-main>
    </el-container>
    <el-aside class="right-aside">
      <el-tabs>
        <el-tab-pane label="组件配置">
          <el-scrollbar>
            <el-row class="not-select" v-if="Object.keys(currentItem).length==0">
              请选择左侧组件
            </el-row>
            <el-form v-else label-width="130px">
              <template v-if="['button'].includes(currentItem.component)">
                <el-form-item label="标签" required>
                  <el-input v-model="currentItem.label" clearable></el-input>
                </el-form-item>
                <el-form-item label="Click事件" required>
                  <el-select v-model="currentItem.click" placeholder="Click成功回调">
                    <el-option v-for="item in prcTemplateClickList" :key="item.value" :label="item.name" :value="item.value"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="Click回调" required>
                  <el-select v-model="currentItem.click_success" multiple placeholder="Click成功回调">
                    <el-option v-for="item in prcTemplateClickSuccessList" :key="item.value" :label="item.name" :value="item.value"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="成功消息">
                  <el-input v-model="currentItem.success_message" clearable></el-input>
                </el-form-item>
                <el-form-item label="栅格列">
                  <el-select v-model="currentItem.span" clearable>
                    <el-option v-for="(item,index) in 24" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="样式">
                  <el-input v-model="currentItem.style" clearable></el-input>
                </el-form-item>
              </template>
              <template v-else>
                <el-form-item label="DataKey" required>
                  <el-input v-model="currentItem.data_key" clearable></el-input>
                </el-form-item>
                <el-form-item label="ParentDataKey">
                  <el-input v-model="currentItem.parent_data_key" clearable></el-input>
                </el-form-item>
                <el-form-item label="标签" required>
                  <el-input v-model="currentItem.label" clearable></el-input>
                </el-form-item>
                <el-form-item label="数据源" v-if="['select'].includes(currentItem.component)">
                  <el-select v-model="currentItem.data_source" placeholder="Click成功回调">
                    <el-option v-for="item in prcTemplateDataSourceList" :key="item.value" :label="item.name" :value="item.value"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="默认值" v-if="!['button'].includes(currentItem.component)">
                  <el-input v-model="currentItem.default_value" clearable></el-input>
                </el-form-item>
                <el-form-item label="类型" v-if="['input'].includes(currentItem.component)">
                  <el-select v-model="currentItem.type" clearable>
                    <el-option label="文本" value="text"></el-option>
                    <el-option label="文本域" value="textarea"></el-option>
                    <el-option label="密码" value="password"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="隐藏">
                  <el-switch v-model="currentItem.hide"></el-switch>
                </el-form-item>
                <el-form-item label="必须">
                  <el-switch v-model="currentItem.required"></el-switch>
                </el-form-item>
                <el-form-item label="转换器">
                  <el-input v-model="currentItem.transfer" clearable></el-input>
                </el-form-item>
                <el-form-item label="Change方法">
                  <el-input v-model="currentItem.change" clearable></el-input>
                </el-form-item>
                <el-form-item label="Change回调">
                  <el-input v-model="currentItem.change_success" clearable></el-input>
                </el-form-item>
                <el-form-item label="格式化方法">
                  <el-input v-model="currentItem.format" clearable></el-input>
                </el-form-item>
                <el-form-item label="栅格列">
                  <el-select v-model="currentItem.span" clearable>
                    <el-option v-for="(item,index) in 24" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="样式">
                  <el-input v-model="currentItem.style" clearable></el-input>
                </el-form-item>
              </template>

            </el-form>
          </el-scrollbar>
        </el-tab-pane>

      </el-tabs>
    </el-aside>

  </el-container>
</template>

<script>
import draggable from "vuedraggable";
import {nanoid} from "nanoid";

export default {
  name: "FrameFormDesigner",
  components: {draggable},
  emits: ['finish'],
  props: {
    initFormData: {
      type: Object
    },
  },
  data() {
    return {
      drag: false,
      componentList: [
        {component: "input", label: "文本框", icon: "input"},
        {component: "input_number", label: "数字输入框", icon: "number"},
        {component: "select", label: "下拉选择框", icon: "select"},
        {component: "date_picker", label: "日期选择器", icon: "date"},
        {component: "cascader", label: "级联选择器", icon: "cascader"},
        {component: "switch", label: "Switch开关", icon: "radio"},
        {component: "file_upload", label: "文件上传", icon: "upload"},
        {component: "image_upload", label: "图片上传", icon: "upload"},
        {component: "button", label: "按钮", icon: "button"},
        {component: "row", label: "栅格", icon: "row"}
      ],
      selectIdx: 0,
      formInfo: {},
      formConfig: this.initFormData || {
        id: nanoid(),
        config_type: 'form',
        label_width: 120,
        items: []
      }
    }
  },
  computed: {
    prcTemplateClickList() {
      return this.$store.getters['core/getDictList']('prc_template_click');
    },
    prcTemplateClickSuccessList() {
      return this.$store.getters['core/getDictList']('prc_template_click_success');
    },
    prcTemplateDataSourceList() {
      return this.$store.getters['core/getDictList']('prc_template_data_source');
    },
    currentItem() {
      return this.formConfig.items[this.selectIdx] || {}
    }
  },
  methods: {
    empty() {
      this.$confirm('您确定要清空所有组件吗？', '提示', {type: 'warning'}).then(
          () => {
            this.formConfig.items = []
          }
      )
    },
    finish() {
      this.$emit('finish', this.formConfig)
    },
    isSelect(itemIdx) {
      return itemIdx == this.selectIdx
    },
    selectWidget(itemIdx) {
      this.selectIdx = itemIdx
    },
    widgetClone(item) {
      let obj = {
        component: item.component,
        label: item.label
      };
      obj.data_key = 'field_name';

      return obj

    },
    deleteWidget(idx) {
      this.formConfig.items.splice(idx, 1)
    },
    copyWidget(idx) {
      this.formConfig.items.push(this.widgetClone(this.formConfig.items[idx]))
    },
    onDragAdd(event) {
      let b = !this.formConfig.items[event.newIndex];
      if (!b) {
        this.selectWidget(event.newIndex);
      }
    }
  }
}
</script>

<style scoped lang="less">
.form-container {
  height: 100%;
}

.left-aside {
  width: 140px;
  border-right: 2px dotted #ddd;

  .header {
    height: 40px;
    border-bottom: 2px dotted #ddd;
    line-height: 38px;
    padding: 0 10px;
    font-weight: bold;
  }
}

.component-group {
  padding: 0 10px;

  .title {
    margin: 10px 0;
  }

  .draggable {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .component-item {
    width: 110px;
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 28px;
    height: 28px;
    border-radius: 2px;
    color: #444;
    background-color: #f4f6fc;
    border: 1px solid #f4f6fc;
    margin: 2px 0;
    display: flex;

    .icon {
      font-size: 16px;
      display: inline-block;
      vertical-align: middle;
      margin-left: 4px;
      margin-right: 2px;
      width: 24px;
      text-align: center;
    }

  }

  .component-item:hover {
    color: #409eff;
    border: 1px dashed #409eff;
    cursor: move;
  }

}


.main-container {
  .header {
    height: 40px;
    border-bottom: 2px dotted #ddd;
    line-height: 38px;
    text-align: right;
  }

  .frame-main {
    background-color: #f1f2f3;
    padding: 10px;
    height: 100%;
  }

  .frame-main-content {
    padding: 10px;
    background-color: #fff;
    height: 100%;
    text-align: left;
  }

  :deep(.el-scrollbar .el-scrollbar__view) {
    padding-bottom: 0;
    height: 100%;
  }

  .form-item {
    position: relative;
    margin-bottom: 5px;
  }

  .form-item.selected {
    outline: 2px solid #409EFF;
  }

  .form-item-list {
    height: 100%;
  }

  .drag-control {
    .icon {
      line-height: 24px;
      width: 24px;
      height: 24px;
      color: #fff;
    }

    .drag-move {
      position: absolute;
      left: -1px;
      top: -1px;
      width: 24px;
      height: 24px;
      line-height: 24px;
      background: var(--el-color-primary);
      color: #fdf6ec;
      text-align: center;
      cursor: move;
    }

    .item-control {
      position: absolute;
      right: -1px;
      bottom: -1px;
      display: flex;
      align-items: center;
      height: 24px;
      background: var(--el-color-primary);
      cursor: pointer;
    }
  }


  .ghost {
    content: "";
    font-size: 0;
    height: 3px;
    background: #409EFF;
    box-sizing: border-box;
    border: 2px solid #409EFF;
    outline-width: 0;
    overflow: hidden;
    padding: 0;

  }

  .not-select {
    justify-content: center;
    font-size: 24px;
    color: #ccc;
    top: 50px;
    position: absolute;
    width: 100%;

  }

}


.right-aside {
  width: 400px;
  border-left: 2px dotted #ddd;
  padding-right: 10px;
  padding-left: 10px;

  .not-select {
    justify-content: center;
    font-size: 16px;
    color: #ccc;
    padding-top: 50px;
  }

}


</style>